/**
 * ============================================================
 * 开场动画配置
 * ============================================================
 * PC 和移动端共用此配置
 *
 * skipIntro      - 开发调试用：设为 true 跳过开场动画，直接进入场景
 * titleImgSrc    - 大标题图片路径
 * introFrameSrc  - 开场弹框背景框图片
 * introSkipSrc   - 开场弹框"跳过"按钮图片
 * fullText       - 弹框中显示的完整文字（使用 \n 换行）
 */
export var skipIntro = false;
export var titleImgSrc = "./xiangan/大标题.webp";
export var introFrameSrc = "./dazi/框.png";
export var introSkipSrc = "./dazi/跳过.webp";

export var fullText = "";

